import { atom } from "jotai";

import { BookingWizard } from "../../types";

/**
 * This just indicates the current step we are on, and works in conjunction
 * with the list of steps to determine which to go forward/back to.
 */
export const CurrentBookingWizardStepAtom =
  atom<BookingWizard.BookingWizardStepTitle | null>(null);
